exports = module.exports = require("../../../../../../build/node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".lottery-button{display:-webkit-box;display:-webkit-flex;display:flex;-webkit-box-align:center;-webkit-align-items:center;align-items:center;-webkit-box-pack:center;-webkit-justify-content:center;justify-content:center;background:#f2f2f2;border-radius:6px;font-size:14px;color:#303133;padding:9px;font-weight:700;width:100%;cursor:pointer;-webkit-user-select:none;user-select:none}.lottery-button.primary{background-image:-webkit-linear-gradient(53deg,#ffb422,#ffe363);background-image:linear-gradient(37deg,#ffb422,#ffe363)}.lottery-button.white{background-color:#fff}.lottery-button.disabled{background:#f2f2f2;color:#ccc}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"scoped":false,"sourceMap":false}!./node_modules/sass-loader/dist/cjs.js!../src/component/game-lottery/component/lottery-button-base/scss/index.scss
// module id = 802
// module chunks = 0 1